/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, Checkbox, MenuItem } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
// import DatePicker from "../../../appointment/DirectAppointment/components/DatePicker/DatePicker";
import DatePicker from "./DatePicker/DatePicker";
import {
  ACTIVE,
  AlertStatus,
  DEACTIVATED,
  DEACTIVATE_REASONS,
  DUPLICATE_REASONS_CHECKBOX,
  ETERNAL_COMRADES_CASES,
} from "../../../../contants";
import Member from "../../../../services/api/member";
// import AppointMentBoolInput from "../../../../components/AppointMentBoolInput/AppointMentBoolInput";
import AppointMentBoolInput from "../../../../components/AppointMentBoolInput/AppointMentBoolInput";
import styles from "./MemberToggleStatus.styles";
import InputField from "../../../../components/common/new/InputField/InputField";
import Typography from "../../../../components/common/new/Typography/Typography";
import Button from "../../../../components/common/Button";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { GOHONZON } from "../utils";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getOptions } from "../../../../utils";

export const FIELDS = {
  REASON: "reason",
  NATIONALITY_ID: "nationalityId",
  ETERNAL_COMERADE_STATUS: "eternalComeradeStatus",
  RETAIN_MEMBER_ID: "retainMemberId",
  REMARKS: "remark",
  SUBMITTED_TO_BSG_OFFICE: "submittedToBsgOffice",
  NAME_OF_LEADER_RECEIVED_GOHONZON: "nameOfLeaderReceivedGohonzon",
  DATE_OF_SUBMISSION_GOHONZON: "dateOfSubmissionGohonzon",
  NAME_STAFF_RECEIVE_GOHONZON: "nameOfStaffReceivedGohonzon",
  MEMBER_ID_RECEIVE_GOHONZON: "memberIdReceivedGohonzon",
  GOHONZON_MEMBER_ID: "gohonzonMemberId",
  GOHONZON_MEMBER_NAME: "gohonzonMemberName",
  COUNTRY: "country",
  ADDRESS: "address",
  CONTACT_NUMBER: "contactNumber",
};

const REMARK = "remark";

function MemberDirectDeactivationHelpDesk({
  selectedMember,
  onClose,
  callBack,
  forHelpdesk,
}) {
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [retainMemberId, setRetainMemberId] = useState("");
  const toast = useContext(ToastAlertContext);
  const isActive = selectedMember?.status === ACTIVE;
  const isDeactivated = selectedMember?.member?.status === DEACTIVATED;
  const [selectedCheckbox, setSelectedCheckbox] = useState("");
  const [isNumber, setIsNumber] = useState(true);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const [gohonzonMemberId, setGohonzonMemberId] = useState("");
  const [gohonzonMemberName, setGohonzonMemberName] = useState("");
  const [gohonzonMemberIdStaff, setGohonzonMemberIdStaff] = useState("");
  const [nameOfLeaderReceivedGohonzon, setNameOfLeaderReceivedGohonzon] =
    useState("");
  const [dateOfSubmissionGohonzon, setDateOfSubmissionGohonzon] = useState(
    new Date()
  );
  const [nameOfStaffReceivedGohonzon, setNameOfStaffReceivedGohonzon] =
    useState("");
  const [submittedToBsg, setSubmittedtoBsg] = useState("");
  const [countries, setCountries] = useState([]);
  const [gohonzonMembersDetails, setGohonzonMemberDetails] = useState([]);
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [status, setStatus] = useState("");
  const [eternalComeradeStatus, setEtarnalComeradeStatus] = useState("");
  const [formattedMsgforHelpdesk, setFormattedMsgForHelpdesk] = useState("");

  const getTitle = () =>
    isHelpDesk || isHelpDeskAdmin
      ? "Verify Member Deactivation"
      : "Reason for Deactivating the Member";

  useEffect(() => {
    if (selectedMember?.reason) {
      setReason(selectedMember.reason);
    }
  }, [selectedMember]);

  useEffect(() => {
    if (
      selectedMember &&
      selectedMember.remarks &&
      selectedMember.remarks.length > 0
    ) {
      setFormattedMsgForHelpdesk(selectedMember.remarks[0].data.message);
    }
  }, [selectedMember]);

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  const getMemberDetailsbyId = async () => {
    const response = await Member.getMemberDetailsById(
      selectedMember?.memberId
    );
    setGohonzonMemberDetails(response?.data?.gohonzonMemberships);
  };

  useEffect(() => {
    getCountries();
    getMemberDetailsbyId();
  }, []);

  const handleEternalComeradeChange = (e) => {
    const { name, value } = e.target;
    if (name === FIELDS.SUBMITTED_TO_BSG_OFFICE) {
      setSubmittedtoBsg(value);
    }
    if (name === FIELDS.NAME_OF_LEADER_RECEIVED_GOHONZON) {
      setNameOfLeaderReceivedGohonzon(value);
    }
    if (name === FIELDS.DATE_OF_SUBMISSION_GOHONZON) {
      setDateOfSubmissionGohonzon(value);
    }
    if (name === FIELDS.NAME_STAFF_RECEIVE_GOHONZON) {
      setNameOfStaffReceivedGohonzon(value);
    }
    if (name === FIELDS.MEMBER_ID_RECEIVE_GOHONZON) {
      setGohonzonMemberIdStaff(value);
    }
    if (name === FIELDS.GOHONZON_MEMBER_NAME) {
      setGohonzonMemberName(value);
    }
    if (name === FIELDS.GOHONZON_MEMBER_ID) {
      setGohonzonMemberId(value);
    }
  };

  const handleOverseasComeradeChange = (e) => {
    const { name, value } = e.target;
    if (name === FIELDS.COUNTRY) {
      setCountry(value);
    }
    if (name === FIELDS.ADDRESS) {
      setAddress(value);
    }
    if (name === FIELDS.CONTACT_NUMBER) {
      setContactNumber(value);
    }
  };

  const handleEternalComeradeDropdownChange = (e) => {
    setEtarnalComeradeStatus(e.target.value);
  };
  const onDateSelect = (appointedAt) => {
    setDateOfSubmissionGohonzon(new Date(appointedAt));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox" && reason === "DUPLICATE_MEMBER") {
      setSelectedCheckbox({ ...selectedCheckbox, [name]: checked });
    } else if (name === REMARK) {
      setRemark(value);
    } else if (name === "reason") {
      setReason(value);
    } else if (name === "memberIdToRetain" && reason === "DUPLICATE_MEMBER") {
      setRetainMemberId(value);
      setIsNumber(!isNaN(value));
    }
  };

  const validateFormData = () => {
    if (isActive && !reason) {
      return "Please select valid reason";
    }
    if (reason === "DUPLICATE_MEMBER" && !retainMemberId && !forHelpdesk) {
      return "Please enter a Member ID you want to retain";
    }
    if (!isNumber) {
      return "Please enter a valid Member ID";
    }
    if (!remark) {
      return "Please enter remarks.";
    }
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const error = validateFormData();
      if (error) throw new Error(error);
      let formattedMsg = "";
      if (country !== "" || address !== "" || contactNumber !== "") {
        formattedMsg += "";

        if (country !== "") {
          formattedMsg += `Country: ${country}\n`;
        }
        if (address !== "") {
          formattedMsg += `Address: ${address}\n`;
        }
        if (contactNumber !== "") {
          formattedMsg += `Contact Number: ${contactNumber}`;
        }
      }
      if (gohonzonMemberId !== "" || gohonzonMemberName !== "") {
        formattedMsg += "";

        if (gohonzonMemberId !== "") {
          formattedMsg += `Member Id: ${gohonzonMemberId}\n`;
        }
        if (gohonzonMemberName !== "") {
          formattedMsg += `Member Name: ${gohonzonMemberName}`;
        }
      }
      if (
        submittedToBsg !== "" ||
        nameOfLeaderReceivedGohonzon !== "" ||
        dateOfSubmissionGohonzon === new Date() ||
        nameOfStaffReceivedGohonzon !== "" ||
        gohonzonMemberIdStaff !== ""
      ) {
        formattedMsg += "";
        if (submittedToBsg !== "") {
          formattedMsg += `Submitted To Bsg: ${submittedToBsg}\n`;
        }
        if (nameOfLeaderReceivedGohonzon !== "") {
          formattedMsg += `Leader Received Gohonzon: ${nameOfLeaderReceivedGohonzon}\n`;
        }
        if (dateOfSubmissionGohonzon !== new Date()) {
          formattedMsg += `Gohonzon Date:${format(
            dateOfSubmissionGohonzon,
            "dd-MM-yyyy"
          )}\n`;
        }
        if (nameOfStaffReceivedGohonzon !== "") {
          formattedMsg += `Received Gohonzon: ${nameOfStaffReceivedGohonzon}\n`;
        }
        if (gohonzonMemberIdStaff !== "") {
          formattedMsg += `Member Id who received gohonzon: ${gohonzonMemberIdStaff}`;
        }
      }
      if (!formattedMsg.trim()) {
        formattedMsg = formattedMsgforHelpdesk;
      }
      // Valid form data
      let body = {
        remark,
        reason,
      };
      // const newBody = {
      //   // remark,
      //   reason,
      //   remarkDto: [
      //     {
      //       data: {
      //         message: formattedMsg,
      //         event: "deactivation",
      //       },
      //     },
      //     {
      //       data: {
      //         message: remark,
      //         event: "remarks",
      //       },
      //     },
      //   ],
      //   memberIdToRetain: retainMemberId.trim() ? retainMemberId : null,
      //   duplicateEntryData: Object.keys(selectedCheckbox).length
      //     ? selectedCheckbox
      //     : null,
      // };
      // const newBody = {
      //   reason,
      //   remarkDto: [],
      //   memberIdToRetain: retainMemberId.trim() ? retainMemberId : null,
      //   duplicateEntryData: Object.keys(selectedCheckbox).length
      //     ? selectedCheckbox
      //     : null,
      // };

      // if (forHelpdesk) {
      //   newBody.remarkDto.push({
      //     data: {
      //       message: remark,
      //       event: "remarkbyhelpdesk",
      //     },
      //   });
      // } else {
      //   // Add two remark objects in an array
      //   newBody.remarkDto.push(
      //     {
      //       data: {
      //         message: formattedMsg,
      //         event: "deactivation",
      //       },
      //     },
      //     {
      //       data: {
      //         message: remark,
      //         event: "remarks",
      //       },
      //     }
      //   );
      // }

      let newBody;

      if (forHelpdesk) {
        newBody = {
          reason,
          data: {
            message: remark,
            event: "remarkbyhelpdesk",
          },
          memberIdToRetain: retainMemberId.trim() ? retainMemberId : null,
          duplicateEntryData: Object.keys(selectedCheckbox).length
            ? selectedCheckbox
            : null,
        };
      } else {
        newBody = {
          reason,
          remarkDto: [
            {
              data: {
                message: formattedMsg,
                event: "deactivation",
              },
            },
            {
              data: {
                message: remark,
                event: "remarks",
              },
            },
          ],
          memberIdToRetain: retainMemberId.trim() ? retainMemberId : null,
          duplicateEntryData: Object.keys(selectedCheckbox).length
            ? selectedCheckbox
            : null,
        };
      }

      if (isActive) {
        if (reason === "DUPLICATE_MEMBER") {
          body = {
            ...newBody,
            reason,
            // memberIdToRetain: retainMemberId,
            // duplicateEntryData: selectedCheckbox,
          };
        } else {
          body = {
            ...newBody,
            reason,
          };
        }
      }

      //   const res = await Member[
      //     isActive ? "memberDeactivate" : "memberDeactivationVerification"
      //   ]({
      //     data: newBody,
      //     memberId: selectedMember?.memberId,
      //     applicationId: selectedMember?.id,
      //   });
      if (
        reason === "ETERNAL_COMRADES" &&
        eternalComeradeStatus === "GOHONZON_TRANSFERRED_TO_PRACTICING_MEMBER"
      ) {
        await Member.memberDirectDeactivateWithTransferMemberId({
          data: newBody,
          applicationId: selectedMember?.memberId,
          transferToMemberId: gohonzonMemberId,
        });
        toast.show("Member deactivated successfully", AlertStatus.SUCCESS);
      } else {
        await Member.memberDirectDeactivate({
          data: newBody,
          applicationId: selectedMember?.memberId,
        });
        toast.show("Member deactivated successfully", AlertStatus.SUCCESS);
      }
      //   await Member.memberDirectDeactivate({
      //     data: newBody,
      //     applicationId: selectedMember?.memberId,
      //   });
      //   toast.show("Member deactivated successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  console.log("selected Member", selectedMember);
  return (
    <Formik
      initialValues={{
        [FIELDS.REASON]: selectedMember?.reason,
        [FIELDS.ETERNAL_COMERADE_STATUS]: selectedMember?.eternalComeradeStatus,
        [FIELDS.REMARKS]: selectedMember?.remark,
        [FIELDS.RETAIN_MEMBER_ID]: selectedMember?.memberIdToRetain,
        [FIELDS.SUBMITTED_TO_BSG_OFFICE]: selectedMember?.submittedToBsgOffice,
        [FIELDS.GOHONZON_MEMBER_ID]: null,
        [FIELDS.GOHONZON_MEMBER_NAME]: null,
        [FIELDS.ADDRESS]: null,
        [FIELDS.COUNTRY]: selectedMember?.country,
        [FIELDS.CONTACT_NUMBER]: null,
        duplicateEntryData: selectedMember?.duplicateEntryData || {},
      }}
    >
      {({ values }) => (
        <form onSubmit={onSubmit}>
          {/* {(isActive || isDeactivated) && ( */}
          <Box>
            <Typography fontWeight={500}>{getTitle()}</Typography>
            <Box padding="15px 0px 15px 0px">
              <InputField
                // disabled={isHelpDesk || isHelpDeskAdmin}
                name="reason"
                label={
                  isHelpDesk || isHelpDeskAdmin
                    ? "Reason for deactivation"
                    : "Select your reason for deactivation"
                }
                select
                value={values[FIELDS.REASON]}
                onChange={handleInputChange}
                inputProps={{ required: true }}
              >
                {DEACTIVATE_REASONS.map((option) => (
                  <MenuItem value={option.value}>{option.displayName}</MenuItem>
                ))}
              </InputField>
            </Box>
            {reason === "ETERNAL_COMRADES" &&
              gohonzonMembersDetails?.length > 0 && (
                <Box padding="15px 0px 15px 0px">
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="eternalComeradeStatus"
                    label="Select Gohonzon Type"
                    select
                    value={values[FIELDS.ETERNAL_COMERADE_STATUS]}
                    onChange={handleEternalComeradeDropdownChange}
                    inputProps={{ required: true }}
                  >
                    {ETERNAL_COMRADES_CASES.map((option) => (
                      <MenuItem value={option.value}>
                        {option.displayName}
                      </MenuItem>
                    ))}
                  </InputField>
                </Box>
              )}
            {reason === "ETERNAL_COMRADES" &&
              eternalComeradeStatus === "GOHONZON_RETURNED" && (
                <Box style={{ marginTop: "24px" }}>
                  <Typography fontWeight={500}>
                    Please Fill the Below Details
                  </Typography>
                  <AppointMentBoolInput
                    labelStyles={{
                      width: "68%",
                      paddingRight: "60px",
                    }}
                    name={FIELDS.SUBMITTED_TO_BSG_OFFICE}
                    value={values[FIELDS.SUBMITTED_TO_BSG_OFFICE]}
                    handleChange={handleEternalComeradeChange}
                    preLabel={<>Submitted to BSG's Office</>}
                    required
                  />{" "}
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="nameOfLeaderReceivedGohonzon"
                    label="Name of the leader who received the gohonzon"
                    value={values[FIELDS.NAME_OF_LEADER_RECEIVED_GOHONZON]}
                    onChange={handleEternalComeradeChange}
                    style={{ marginTop: "12px" }}
                  />
                  <Box sx={{ marginTop: "15px" }}>
                    <DatePicker
                      defaultValue={dateOfSubmissionGohonzon}
                      disableFuture
                      onDateSelect={onDateSelect}
                    >
                      <Typography
                        weight={500}
                        variant="small"
                        style={{
                          border: "1px solid #897c6f ",
                          borderRadius: "8px",
                          width: "100%",
                          padding: "7.5px 14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {dateOfSubmissionGohonzon
                          ? format(dateOfSubmissionGohonzon, "dd-MM-yyyy")
                          : "NA"}
                        <CalendarMonthOutlinedIcon
                          style={{ paddingLeft: "5px" }}
                        />
                      </Typography>
                    </DatePicker>
                  </Box>
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="nameOfStaffReceivedGohonzon"
                    label="Name of Staff who received gohonzon"
                    value={values[FIELDS.NAME_STAFF_RECEIVE_GOHONZON]}
                    onChange={handleEternalComeradeChange}
                    style={{ marginTop: "12px" }}
                  />
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="memberIdReceivedGohonzon"
                    label="Member Id who received gohonzon"
                    value={values[FIELDS.MEMBER_ID_RECEIVE_GOHONZON]}
                    onChange={handleEternalComeradeChange}
                    style={{ marginTop: "12px" }}
                  />
                </Box>
              )}
            {reason === "ETERNAL_COMRADES" &&
              eternalComeradeStatus ===
                "GOHONZON_TRANSFERRED_TO_PRACTICING_MEMBER" && (
                <Box style={{ marginTop: "24px" }}>
                  <Typography fontWeight={500}>
                    Please Fill the Below Details
                  </Typography>
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="gohonzonMemberId"
                    label="Enter the Member ID to transfer the Gohonzon"
                    value={values[FIELDS.GOHONZON_MEMBER_ID]}
                    onChange={handleEternalComeradeChange}
                    style={{ marginTop: "12px" }}
                  />
                  <InputField
                    // disabled={isHelpDesk || isHelpDeskAdmin}
                    name="gohonzonMemberName"
                    label="Enter Member Name"
                    value={values[FIELDS.GOHONZON_MEMBER_NAME]}
                    onChange={handleEternalComeradeChange}
                    style={{ marginTop: "12px" }}
                  />
                </Box>
              )}
            {reason === "OVERSEAS_COMRADES" && (
              <Box style={{ marginTop: "24px" }}>
                <Typography fontWeight={500}>
                  Please Fill the Below Details
                </Typography>
                <AutoCompleteDropdown
                  getOptionLabel={(option) => option.countryName}
                  name="country"
                  options={getOptions(countries, "countryName")}
                  inputProps={{ required: true }}
                  value={country}
                  label="Select Country"
                  onChange={(selectedValue) => {
                    setCountry(selectedValue.value);
                  }}
                />
                <InputField
                  //   disabled={isHelpDesk || isHelpDeskAdmin}
                  name="address"
                  label="Enter Address"
                  value={values[FIELDS.ADDRESS]}
                  onChange={handleOverseasComeradeChange}
                  style={{ marginTop: "12px" }}
                />
                <InputField
                  //   disabled={isHelpDesk || isHelpDeskAdmin}
                  name="contactNumber"
                  label="Enter Contact Number"
                  value={values[FIELDS.CONTACT_NUMBER]}
                  onChange={handleOverseasComeradeChange}
                  style={{ marginTop: "12px" }}
                />
              </Box>
            )}
            {/* {isHelpDesk && reason !== "DUPLICATE_MEMBER" && (
              <div
                style={{
                  background: "#BAD9EC",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              >
                {selectedMember?.remarks[0]?.data?.message
                  .split("\n")
                  .map((line, index) => (
                    <>
                      {line}
                      <br />
                    </>
                  ))}
              </div>
            )} */}

            {reason === "DUPLICATE_MEMBER" ? (
              <Box style={{ marginTop: "24px" }}>
                <Typography fontWeight={500}>
                  Enter Member Id you want to retain
                </Typography>
                <InputField
                  //   disabled={isHelpDesk || isHelpDeskAdmin}
                  name="memberIdToRetain"
                  label="Member ID"
                  value={values[FIELDS.RETAIN_MEMBER_ID]}
                  onChange={handleInputChange}
                  style={{ marginTop: "12px" }}
                />
                <Box style={{ marginTop: "24px" }}>
                  <Typography fontWeight={500}>
                    Details to be merged with retained Member-ID
                  </Typography>
                </Box>
              </Box>
            ) : null}
            <Box style={{ margin: "24px 24px 0px 24px" }}>
              {reason === "DUPLICATE_MEMBER" &&
                DUPLICATE_REASONS_CHECKBOX.map((options) => {
                  return (
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <span
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          {options.displayName}
                        </span>
                      </Box>{" "}
                      <Checkbox
                        // disabled={isHelpDesk || isHelpDeskAdmin}
                        name={options.getValue}
                        value={selectedCheckbox[options.getValue] ?? false}
                        checked={
                          selectedCheckbox[options.getValue] ||
                          values?.duplicateEntryData[options?.getValue]
                        }
                        onChange={handleInputChange}
                      />{" "}
                    </Box>
                  );
                })}
            </Box>
          </Box>
          {/* )} */}
          <Box>
            <InputField
              name={REMARK}
              // disabled={isHelpDesk || isHelpDeskAdmin}
              variant="outlined"
              label={
                isHelpDesk || isHelpDeskAdmin
                  ? "Remark"
                  : "Enter your remark here..."
              }
              style={styles.inputStyle}
              // value={values[FIELDS.REMARKS]}
              onChange={handleInputChange}
              InputProps={{ sx: { minHeight: "91px" } }}
            />
          </Box>
          <div style={{ display: "flex", gap: 20 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              onClick={onSubmit}
              type="submit"
              label={isDeactivated ? "Deactivate" : "submit"}
            />
            <Button
              style={CommonStyles.buttonStyle}
              variant="outlined"
              onClick={onClose}
              label="Cancel"
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default MemberDirectDeactivationHelpDesk;
